/**
 * Contatti dello Studio mostrati nel portale (pagina di rifiuto, footer).
 *
 * Un punto solo: se il numero o l'email cambiano, si cambia qui.
 */

export const STUDIO_EMAIL = 'stucchi@studiodietetico.eu';

/**
 * E.164, senza spazi: unico valore ammesso in href="tel:".
 * Un tel: con spazi non e' affidabile su tutti i client.
 */
export const STUDIO_TELEFONO_E164 = '+393383369477';

/** Forma di lettura in UI. Non usarla nell'attributo href. */
export const STUDIO_TELEFONO = '338 336 9477';
